module.exports = __webpack_public_path__ + "7477154a0cf29d7c66f4d4e43a09cd53.svg";